export enum ETokenModalType {
  Issue = 'Issue',
  Burn = 'Burn',
}

export enum ETokenModalFormFields {
  ReserveBalance = 'reserveBalance',
  Amount = 'amount',
}
